import Tooltip from '@carvana/showroom-tooltip';
import ErrorFilledIcon from './ErrorFilledIcon';

type OwnProps = {
  pricingErrorMessage: string;
};

const PricingErrorTooltip = ({ pricingErrorMessage }: OwnProps) => (
  <div className="absolute">
    <Tooltip
      content={<>{pricingErrorMessage}</>}
      title={'Pricing Error Message'}
      direction="bottom"
      display={{
        width: 295
      }}
    >
      <ErrorFilledIcon />
    </Tooltip>
  </div>
);

export default PricingErrorTooltip;
